import { browserHistory, getLastPathSegment } from 'utils/navigation'
import { getStudyVersionID } from '../../../../../../../../../../../utils/studyConfigUtils'

export const redirectVisit = ({
  visitScheduleSubroute,
  redirectPath,
  studyID,
  visitID,
  queryParams,
  studyVersionID,
}) => {
  if (redirectPath) {
    if (redirectPath === 'visit-schedules' || !visitID) {
      browserHistory.push(`/studies/${studyID}/${studyVersionID}/visit-schedules${queryParams || ''}`)
    } else if (visitScheduleSubroute === 'visit-templates' && redirectPath === 'details' && visitID) {
      browserHistory.push(
        `/studies/${studyID}/${studyVersionID}/visit-schedules/${visitScheduleSubroute}/${visitID}/${redirectPath}${queryParams ||
          ''}`,
      )
    }
  } else {
    browserHistory.push(`/studies/${studyID}/${studyVersionID}/visit-schedules${queryParams || ''}`)
  }
}

export const onRedirectVisit = ({ resJSON, redirectPath, studyID, queryParams, visitScheduleSubroute }) => (
  dispatch,
  getState,
) => {
  const studyVersionID = getStudyVersionID(getState()?.location)
  if (resJSON && !resJSON.ok && resJSON.status === 412) return
  const { location } = getState()
  const path = getLastPathSegment(location?.pathname)
  if (!path) {
    browserHistory.push(`/studies/${studyID}/${studyVersionID}/visit-schedules${queryParams || ''}`)
    return
  }

  // if !study_visit_template_id use the id from the pathname
  const visitID =
    resJSON?.study_visit_template_id || getLastPathSegment(location.pathname.replace(`/${path}`, ''))
  redirectVisit({ redirectPath, studyID, visitID, queryParams, visitScheduleSubroute, studyVersionID })
}
